// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactions{
    height: 450px;
}

.reactions__content{
    margin-left:  var(--space);
    margin-right:  var(--space);
    margin-top: 1%;
}

.reactions__content__box{
    display: flex;
    padding: 5px;
    align-items: center;
    margin-bottom: 2%;
    justify-content: space-between;
}

.reactions__content__box__photo {
    width: var(--space-x3);
    height: var(--space-x3);
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    margin-right: var(--space);
    background: var(--primary-light-color);    
    cursor: pointer;
    display: flex;
    align-items: center;
}

.reactions__content__box__photo img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
}

.reactions__content__box__photo .icon-ball{
    font-size: calc(var(--space-x2) + var(--space-quarter)); /*36px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-x2) + var(--space-quarter) + calc(6px * 2));/*48px*/
    color: var(--white-color);
    margin-right: var(--space-half);
}

.reactions__content__box__info-username {
    max-height: var(--space-x2);
    flex-grow: 1;
    cursor: pointer;
}

.reactions__content__box__button {
    align-items: center;
    
}

.reactions__bottom{
    background-color: var(--white-color);
    height: var(--space-x2);

}

.reactions__modal__icon{
    font-size: var(--space-x2);
}

.reactions__modal__icon-text{
    font-size: calc(var(--space) + var(--space-quarter));
    align-items: center;
    display: flex;
    text-transform: capitalize;
}

.reactions__modal__tabs .MuiTab-wrapper{
    flex-direction: row;
}

.reactions__modal__tabs .MuiTab-root{
    max-width: calc(var(--space-x3) * 3);
}
.MuiTabs-root.reactions__modal__tabs {
    min-height: 54px; /*TODO: revisar con cambio UI*/
    max-height: 70px; /*TODO: revisar con cambio UI*/
}
.reactions__modal__tabs .MuiTab-labelIcon{
    padding-top: 0;
}

@media (min-width: 600px){
    .reactions__modal__tabs .MuiTab-root {
        min-width: calc(var(--space-x3) * 3);
    }
}

.reactions__modal__tabs .MuiTabs-flexContainer {
    display: flex;
    border-bottom: none;
}

.report-post__form__actions__cancel-btn{
    margin-right: calc(var(--space) + var(--space-quarter));
}
`, "",{"version":3,"sources":["webpack://./src/app/posts/components/reactions-modal/ReactionsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,sCAAsC;IACtC,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,uDAAuD,EAAE,OAAO;IAChE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,oEAAoE,CAAC,OAAO;IAC5E,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;;AAE3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB,EAAE,8BAA8B;IAChD,gBAAgB,EAAE,8BAA8B;AACpD;AACA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uDAAuD;AAC3D","sourcesContent":[".reactions{\n    height: 450px;\n}\n\n.reactions__content{\n    margin-left:  var(--space);\n    margin-right:  var(--space);\n    margin-top: 1%;\n}\n\n.reactions__content__box{\n    display: flex;\n    padding: 5px;\n    align-items: center;\n    margin-bottom: 2%;\n    justify-content: space-between;\n}\n\n.reactions__content__box__photo {\n    width: var(--space-x3);\n    height: var(--space-x3);\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    position: relative;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-right: var(--space);\n    background: var(--primary-light-color);    \n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.reactions__content__box__photo img {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 50%;\n}\n\n.reactions__content__box__photo .icon-ball{\n    font-size: calc(var(--space-x2) + var(--space-quarter)); /*36px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-x2) + var(--space-quarter) + calc(6px * 2));/*48px*/\n    color: var(--white-color);\n    margin-right: var(--space-half);\n}\n\n.reactions__content__box__info-username {\n    max-height: var(--space-x2);\n    flex-grow: 1;\n    cursor: pointer;\n}\n\n.reactions__content__box__button {\n    align-items: center;\n    \n}\n\n.reactions__bottom{\n    background-color: var(--white-color);\n    height: var(--space-x2);\n\n}\n\n.reactions__modal__icon{\n    font-size: var(--space-x2);\n}\n\n.reactions__modal__icon-text{\n    font-size: calc(var(--space) + var(--space-quarter));\n    align-items: center;\n    display: flex;\n    text-transform: capitalize;\n}\n\n.reactions__modal__tabs .MuiTab-wrapper{\n    flex-direction: row;\n}\n\n.reactions__modal__tabs .MuiTab-root{\n    max-width: calc(var(--space-x3) * 3);\n}\n.MuiTabs-root.reactions__modal__tabs {\n    min-height: 54px; /*TODO: revisar con cambio UI*/\n    max-height: 70px; /*TODO: revisar con cambio UI*/\n}\n.reactions__modal__tabs .MuiTab-labelIcon{\n    padding-top: 0;\n}\n\n@media (min-width: 600px){\n    .reactions__modal__tabs .MuiTab-root {\n        min-width: calc(var(--space-x3) * 3);\n    }\n}\n\n.reactions__modal__tabs .MuiTabs-flexContainer {\n    display: flex;\n    border-bottom: none;\n}\n\n.report-post__form__actions__cancel-btn{\n    margin-right: calc(var(--space) + var(--space-quarter));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
